<button
  class="btn btn-sm btn-outline-secondary"
  [disabled]="disabled"
  (click)="showReports()"
>
  Reports
</button>
